import NotFound from "./pages/NotFound";
import Dashboard from "./pages/adminV2/trucks/Dashboard";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
// import AdminLayout from "./components/AdminLayout";
import Renters from "./pages/admin/renters";
import Rentees from "./pages/admin/rentees";
import Categories from "./pages/admin/categories";
import GuestRoute from "./components/GuestRoute";
import Brands from "./pages/admin/brands";
import Commissions from "./pages/admin/commission";
import ShowCategory from "./pages/admin/categories/ShowCategory";
import ErrorBoundary from "./components/ErrorBoundary";
import Administrators from "./pages/admin/administrators";
import Materials from "./pages/admin/materials";
import ShowMaterial from "./pages/admin/materials/ShowMaterial";
import Partners from "./pages/admin/partners";
import Requests from "./pages/admin/requests";
import SysPayoutRequests from "./pages/admin/requests/payout-requests";
import ShowTruck from "./pages/admin/trucks/ShowTruck";
import ShowPartner from "./pages/admin/partners/ShowPartner";
import ShowCommission from "./pages/admin/commission/ShowCommission";
import ShowRenter from "./pages/admin/renters/ShowRenter";
import ShowRentees from "./pages/admin/rentees/ShowRentees";
import Enquiries from "./pages/admin/enquiries";
import ShowEnquiry from "./pages/admin/enquiries/show";
import Tracking from "./pages/admin/trucks/Tracking";
import LoginForm from "./auth/LoginV2";
import LayoutView from "./componentsV2/LayoutView";
import Users from "./pages/adminV2/users/Users";
import TruckCategories from "./pages/adminV2/trucks/TruckCategory";
import CreateTruckCategory from "./pages/adminV2/trucks/CreateTruckCatetgory";
import EditTruckCategory from "./pages/adminV2/trucks/EditTruckCategory";
import CategoryDetails from "./pages/adminV2/trucks/CategoryDetails";
import TruckZones from "./pages/adminV2/zones/truckZones";
import Zones from "./pages/adminV2/zones/zones";
import AdminSettingsPage from "./pages/adminV2/settings";
import AdminSetPassword from "./auth/AdminSetPassword";
import { MapZonePricing } from "./pages/adminV2/zones/MapZonePricing";
import TransactionDetails from "./pages/admin/requests/request";
import TruckRequests from "./pages/adminV2/trucks/TruckRequests";
import TruckRequestDetails from "./pages/adminV2/trucks/TruckRequestDetails";
import TruckTracking from "./pages/adminV2/trucks/TruckTracking";
import UserTransactions from "./pages/adminV2/users/UserTransactions";
import PartnerTransactions from "./pages/adminV2/users/PartnerTransactions";
import FleetOwnerTransactions from "./pages/adminV2/users/FleetOwnerTransactions";
import BusinessRenterTransactions from "./pages/adminV2/users/BusinessRenterTransactions";
import FleetOwnerPayouts from "./pages/adminV2/users/FleetOwnerPayouts";
import ReferralAgentTransaction from "./pages/adminV2/users/ReferralAgentTransaction";

const Router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route
        element={
          <ProtectedRoute>
            <LayoutView />
          </ProtectedRoute>
        }
        errorElement={<ErrorBoundary />}
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />

        {/* User Routes */}
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/users/:renterId/renter/transactions" element={<UserTransactions />} />
        <Route path="/admin/users/:renterId/business-renter/transactions" element={<BusinessRenterTransactions />} />
        <Route path="/admin/users/:fleetOwnerId/fleet-owner/transactions" element={<FleetOwnerTransactions />} />
        <Route path="/admin/users/:fleetOwnerId/fleet-owner/payouts" element={<FleetOwnerPayouts />} />
        <Route path="/admin/users/:partnerId/partner/transactions" element={<PartnerTransactions />} />
        <Route path="/admin/users/referral/commission-ledgers" element={<ReferralAgentTransaction />} />
        <Route path="/admin/users/referral/commission-ledgers/:agentId" element={<ReferralAgentTransaction />} />

        {/* Trucks Routes */}
        <Route path="/admin/trucks" element={<TruckCategories />} />
        <Route path="/admin/trucks/create" element={<CreateTruckCategory />} />
        <Route path="/admin/trucks/edit/:categoryId" element={<EditTruckCategory />} />
        <Route path="/admin/trucks/:categoryId" element={<CategoryDetails />} />
        <Route path="/admin/trucks/:truckId/truck" element={<TruckRequests />} />
        <Route path="/admin/trucks/transaction/:requestId" element={<TruckRequestDetails />} />
        <Route path="/admin/trucks/:truckID/tracking" element={<TruckTracking />} />

        {/* Zones Routes */}
        <Route path="/admin/zones" element={<Zones />} />
        <Route path="/admin/zones/truck-zones/:truckId" element={<TruckZones />} />
        <Route path="/admin/zones/map-zone-pricing/:truckId" element={<MapZonePricing />} />

        {/* Settings Routes */}
        <Route path="/admin/settings" element={<AdminSettingsPage />} />

        {/* Others */}
        <Route path="/admin/renters" element={<Renters />} />
        <Route path="/admin/renters/:renterId" element={<ShowRenter />} />
        <Route path="/admin/rentees" element={<Rentees />} />
        <Route path="/admin/rentees/:truckOwnerId" element={<ShowRentees />} />
        <Route path="/admin/partners" element={<Partners />} />
        <Route path="/admin/partners/:partnerId" element={<ShowPartner />} />
        <Route path="/admin/administrators" element={<Administrators />} />
        <Route path="/admin/categories" element={<Categories />} />
        <Route
          path="/admin/categories/:categoryId"
          element={<ShowCategory />}
        />
        <Route path="/admin/brands" element={<Brands />} />
        <Route path="/admin/commissions" element={<Commissions />} />
        <Route
          path="/admin/commissions/:commissionId"
          element={<ShowCommission />}
        />
        <Route path="/admin/truck-categories/:truckId" element={<ShowTruck />} />
        <Route path="/admin/truck-categories/tracking/:truckId" element={<Tracking />} />
        <Route path="/admin/requests" element={<Requests />} />
        <Route path="/admin/payout-requests" element={<SysPayoutRequests />} />
        <Route path="/admin/requests/:requestId" element={<TransactionDetails />} />
        <Route path="/admin/materials" element={<Materials />} />
        <Route path="/admin/materials/:materialId" element={<ShowMaterial />} />
        <Route path="/admin/enquiries/" element={<Enquiries />} />
        <Route path="/admin/enquiries/:enquiryId" element={<ShowEnquiry />} />
        <Route path="*" element={<NotFound />} />
      </Route>

      {/* Guest Route */}
      <Route
        path="login"
        element={
          <GuestRoute>
            <LoginForm />
          </GuestRoute>
        }
      />
      <Route path="trucks/:truckId/tracking" element={<Tracking />} />
      <Route path="set-password" element={<AdminSetPassword />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

export default Router;
